<div class="sp-page">
  <div class="sp-card">
    <div class="sp-container">
      <div class="sp-column sp-gap-lg">

        <!-- ╔══════════════════════════════════════════════════════════════╗ -->
        <!-- ║  PANNEAU HAUT : Formulaire + Filtres                        ║ -->
        <!-- ╚══════════════════════════════════════════════════════════════╝ -->
        <div class="sp-top-panel">

          <!-- ── Carte : Nouvelle intervention ──────────────────────────── -->
          <div class="sp-form-card">
            <div class="sp-form-card__header">
              <div class="sp-form-card__icon">
                <mat-icon>add_task</mat-icon>
              </div>
              <div>
                <h3 class="sp-form-card__title">Nouvelle intervention</h3>
                <p class="sp-form-card__subtitle">Ajouter au niveau racine</p>
              </div>
            </div>

            <div class="sp-form-card__body">
              <div class="sp-field">
                <label class="sp-field__label">
                  <mat-icon class="sp-field__label-icon">category</mat-icon>
                  Type d'intervention
                </label>
                <div class="sp-field__badge-wrap">
                  <span class="sp-badge sp-badge--type">
                    <mat-icon class="sp-badge__icon">verified</mat-icon>
                    {{ lowestLevelTypeIntervention?.libelle || "—" }}
                  </span>
                </div>
              </div>

              <div class="sp-field">
                <label class="sp-field__label" for="sp-intervention-input">
                  <mat-icon class="sp-field__label-icon">title</mat-icon>
                  Intitulé de l'intervention
                </label>
                <div class="sp-field__input-wrap">
                  <input
                    id="sp-intervention-input"
                    type="text"
                    class="sp-field__input"
                    placeholder="Saisir l'intitulé…"
                    [(ngModel)]="intervention"
                    autocomplete="off"
                  />
                  <span class="sp-field__input-line"></span>
                </div>
              </div>
            </div>

            <div class="sp-form-card__footer">
              <app-ui-button
                label="Ajouter"
                variant="primary"
                size="md"
                iconLeft="add_circle_outline"
                [loading]="isLoading"
                [disabled]="isLoading || !intervention.trim()"
                (clicked)="addStructureProgrammatique()"
              />
            </div>
          </div>

          <!-- ── Séparateur vertical ───────────────────────────────────── -->
          <div class="sp-divider-v"></div>

          <!-- ── SearchFilterComponent ─────────────────────────────────── -->
          <app-search-filter
            class="sp-filter-card"
            [searchTerm]="searchTerm"
            [startDate]="filterStartDate"
            [endDate]="filterEndDate"
            (filterChange)="onFilterChange($event)"
            (filterReset)="onFilterReset()"
          />

        </div>
        <!-- ── FIN PANNEAU HAUT ──────────────────────────────────────────── -->

        <!-- ╔══════════════════════════════════════════════════════════════╗ -->
        <!-- ║  TABLE                                                       ║ -->
        <!-- ╚══════════════════════════════════════════════════════════════╝ -->
        <app-loaderIntervantion [isLoading]="isTableLoading" [rows]="8" />

        <div
          class="sp-table-wrapper"
          role="table"
          aria-label="Liste des interventions"
          *ngIf="!isTableLoading"
        >
          <!-- ── En-tête ────────────────────────────────────────────────── -->
          <div class="sp-table-header" role="rowgroup">
            <div class="sp-col" role="columnheader">
              <mat-icon style="font-size:14px;width:14px;height:14px;line-height:14px;opacity:.6">account_tree</mat-icon>
              Intervention
            </div>
            <div class="sp-col sp-text-center" role="columnheader">
              <mat-icon style="font-size:14px;width:14px;height:14px;line-height:14px;opacity:.6">event</mat-icon>
              Début
            </div>
            <div class="sp-col sp-text-center" role="columnheader">
              <mat-icon style="font-size:14px;width:14px;height:14px;line-height:14px;opacity:.6">event_busy</mat-icon>
              Fin
            </div>
            <div class="sp-col sp-text-center" role="columnheader">
              <mat-icon style="font-size:14px;width:14px;height:14px;line-height:14px;opacity:.6">settings</mat-icon>
              Actions
            </div>
          </div>

          <!-- ── Corps ─────────────────────────────────────────────────── -->
          <div class="sp-table-body" role="rowgroup">

            <!-- État vide enrichi -->
            <div *ngIf="filteredStructures.length === 0" class="sp-empty-state">
              <div class="sp-empty-state__icon-wrap">
                <mat-icon>search_off</mat-icon>
              </div>
              <p>Aucune intervention ne correspond aux filtres sélectionnés.</p>
              <span class="sp-empty-state__hint">
                <mat-icon style="font-size:14px;width:14px;height:14px">info_outline</mat-icon>
                Essayez de modifier vos critères de recherche
              </span>
            </div>

            <ng-container *ngFor="let item of getFlatVisibleNodes(); trackBy: trackByFlat">

              <!-- Nœud synthétique "Structure responsable" -->
              <ng-container *ngIf="item.isResponsible; else normalNode">
                <div class="sp-responsible-node" [style.paddingLeft.px]="item.level * 20 + 14" role="row">
                  <div class="sp-responsible-left">
                    <button
                      class="sp-toggle-btn"
                      (click)="toggleChildrenVisibility(item.node.id)"
                      [attr.aria-expanded]="isChildrenVisible(item.node.id)"
                      [title]="'Afficher/masquer ' + item.node.titre"
                    >
                      <mat-icon class="sp-icon sp-icon-orange" [ngClass]="{'sp-rotated': isChildrenVisible(item.node.id)}">
                        arrow_forward_ios
                      </mat-icon>
                    </button>
                    <div class="sp-responsible-title">{{ item.node.titre }}</div>
                  </div>
                  <div class="sp-col"></div>
                  <div class="sp-col"></div>
                  <div class="sp-col"></div>
                </div>
              </ng-container>

              <!-- Nœud normal -->
              <ng-template #normalNode>
                <div
                  class="sp-node"
                  [style.paddingLeft.px]="item.level * 20 + 14"
                  [attr.data-level]="item.level"
                  [ngClass]="{'sp-text-expanded': isTextExpanded(item.node)}"
                  role="row"
                >
                  <!-- Colonne titre -->
                  <div class="sp-node-left">
                    <!-- Bouton toggle si enfants -->
                    <button
                      *ngIf="item.node.enfant?.length"
                      class="sp-toggle-btn"
                      (click)="toggleChildrenVisibility(item.node)"
                      [attr.aria-expanded]="isChildrenVisible(item.node)"
                      title="Afficher/masquer les enfants"
                    >
                      <mat-icon class="sp-icon" [ngClass]="{'sp-rotated': isChildrenVisible(item.node)}">
                        arrow_forward_ios
                      </mat-icon>
                    </button>

                    <div class="sp-node-title-wrap">
                      <!-- Pill de niveau + code -->
                      <span class="sp-node-level-tag">
                        {{ getTypeInterventionLibelle(item.node.typeActivite) }}
                        <ng-container *ngIf="item.node.code"> · {{ item.node.code }}</ng-container>
                        <!-- Badge compteur enfants -->
                        <span
                          *ngIf="item.node.enfant?.length"
                          class="sp-children-count"
                          [title]="item.node.enfant.length + ' sous-intervention(s)'"
                        >{{ item.node.enfant.length }}</span>
                      </span>

                      <!-- Titre -->
                      <div class="sp-node-title" role="cell" [title]="item.node.titre">
                        {{ item.node.titre }}
                      </div>

                      <!-- Dates inline (visible uniquement sur très petit écran < 480px) -->
<!--                       <span
                        class="sp-date-inline"
                        *ngIf="item.node.dateDebut && item.node.dateFin"
                        aria-hidden="true"
                      >
                        <mat-icon style="font-size:11px;width:11px;height:11px;line-height:11px">date_range</mat-icon>
                        {{ formatDateFR(item.node.dateDebut, item.level) }}
                        &rarr;
                        {{ formatDateFR(item.node.dateFin, item.level) }}
                      </span> -->

                      <!-- Voir plus / Voir moins -->
                      <button
                        *ngIf="showSeeMore(item.node, item.level)"
                        class="see-more-btn"
                        (click)="toggleTextExpansion(item.node)"
                        [attr.aria-expanded]="isTextExpanded(item.node)"
                      >
                        {{ isTextExpanded(item.node) ? '▲ Voir moins' : '▼ Voir plus' }}
                      </button>
                    </div>
                  </div>

                  <!-- Date début — visible desktop uniquement -->
                  <div class="sp-col sp-date-cell" role="cell">
                    <div class="sp-date-card" *ngIf="item.node.dateDebut && item.node.dateFin">
                      <mat-icon class="sp-date-card__icon">calendar_today</mat-icon>
                      <span class="sp-date-card__value">{{ formatDateFR(item.node.dateDebut, item.level) }}</span>
                    </div>
                  </div>

                  <!-- Date fin — visible desktop uniquement -->
                  <div class="sp-col sp-date-cell" role="cell">
                    <div class="sp-date-card" *ngIf="item.node.dateDebut && item.node.dateFin">
                      <mat-icon class="sp-date-card__icon">event</mat-icon>
                      <span class="sp-date-card__value">{{ formatDateFR(item.node.dateFin, item.level) }}</span>
                    </div>
                  </div>

                  <!-- Actions — visible desktop uniquement -->
                  <div class="sp-col sp-actions" role="cell">
                    <div class="sp-action-buttons">
                      <div class="sp-action-icon sp-action-view" title="Voir les détails" role="button" tabindex="0"
                        (click)="openDetailsModal(item.node)" (keydown.enter)="openDetailsModal(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">visibility</mat-icon>
                      </div>
                      <div class="sp-action-icon sp-action-edit" title="Éditer" role="button" tabindex="0"
                        (click)="openEditStructureModal(item.node)" (keydown.enter)="openEditStructureModal(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">edit_square</mat-icon>
                      </div>
                      <div *ngIf="canAddChild(item.node)" class="sp-action-icon sp-action-add"
                        title="Ajouter une sous-intervention" role="button" tabindex="0"
                        (click)="openAddSubStructureModal(item.node)" (keydown.enter)="openAddSubStructureModal(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">add_circle</mat-icon>
                      </div>
                      <div class="sp-action-icon sp-action-delete" title="Supprimer" role="button" tabindex="0"
                        (click)="openDeleteConfirm(item.node)" (keydown.enter)="openDeleteConfirm(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">delete</mat-icon>
                      </div>
                    </div>
                  </div>

                  <!-- ══ PIED DE CARTE MOBILE (≤ 480px) ══════════════════════
                       Dates sur une ligne + boutons d'action côte à côte
                       Caché sur desktop (.sp-node-footer-mobile { display:none })
                  ══════════════════════════════════════════════════════════ -->
                  <div class="sp-node-footer-mobile">
                    <!-- Dates inline -->
                    <span class="sp-date-inline" *ngIf="item.node.dateDebut && item.node.dateFin">
                      <mat-icon style="font-size:13px;width:13px;height:13px;line-height:13px">calendar_today</mat-icon>
                      {{ formatDateFR(item.node.dateDebut, item.level) }}
                      <span style="opacity:.35;margin:0 2px">→</span>
                      <mat-icon style="font-size:13px;width:13px;height:13px;line-height:13px">event</mat-icon>
                      {{ formatDateFR(item.node.dateFin, item.level) }}
                    </span>
                    <span class="sp-date-inline sp-date-inline--empty"
                      *ngIf="!item.node.dateDebut || !item.node.dateFin">
                      Pas de dates
                    </span>

                    <!-- Boutons d'action -->
                    <div class="sp-mobile-actions">
                      <div class="sp-action-icon sp-action-view" title="Voir" role="button" tabindex="0"
                        (click)="openDetailsModal(item.node)" (keydown.enter)="openDetailsModal(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">visibility</mat-icon>
                      </div>
                      <div class="sp-action-icon sp-action-edit" title="Éditer" role="button" tabindex="0"
                        (click)="openEditStructureModal(item.node)" (keydown.enter)="openEditStructureModal(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">edit_square</mat-icon>
                      </div>
                      <div *ngIf="canAddChild(item.node)" class="sp-action-icon sp-action-add"
                        title="Ajouter" role="button" tabindex="0"
                        (click)="openAddSubStructureModal(item.node)" (keydown.enter)="openAddSubStructureModal(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">add_circle</mat-icon>
                      </div>
                      <div class="sp-action-icon sp-action-delete" title="Supprimer" role="button" tabindex="0"
                        (click)="openDeleteConfirm(item.node)" (keydown.enter)="openDeleteConfirm(item.node)">
                        <mat-icon class="sp-icon-click" aria-hidden="true">delete</mat-icon>
                      </div>
                    </div>
                  </div>

                </div>
              </ng-template>

            </ng-container>
          </div><!-- /.sp-table-body -->
        </div>
        <!-- ── FIN TABLE ─────────────────────────────────────────────────── -->

      </div>

      <!-- Modals via ngTemplateOutlet -->
      <ng-container *ngTemplateOutlet="modalAddSub" />
      <ng-container *ngTemplateOutlet="modalEdit" />
      <ng-container *ngTemplateOutlet="modalDetails" />

    </div>
  </div>
</div>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- CONFIRM DELETE                                                            -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- Avant : 2 blocs séparés (app-confirm-dialog + div cd-backdrop) -->
<!-- Après : 1 seul composant -->

<app-confirm-dialog
  [isVisible]="showDeleteConfirm || showDeleteBlocked"
  title="Supprimer l'intervention"
  message="Cette action est irréversible. L'intervention sera définitivement supprimée."
  [itemLabel]="deleteTargetLabel"
  [blockedChildCount]="showDeleteBlocked ? deleteTargetChildCount : 0"
  confirmLabel="Supprimer"
  cancelLabel="Annuler"
  [isLoading]="isDeletingItem"
  (confirmed)="confirmDelete()"
  (cancelled)="cancelDelete(); closeDeleteBlocked()"
/>
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- MODAL : Ajouter une sous-intervention                                     -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<ng-template #modalAddSub>
  <app-modal
    [isVisible]="showAddStructprogrammatique"
    title="Ajouter une sous-intervention"
    (closeEvent)="closeAddSubStructureModal()"
  >
    <div class="sp-modal-content">
      <div class="sp-modal-scrollable">

        <div class="sp-parent-banner">
          <span class="material-icons sp-parent-banner__icon">account_tree</span>
          <span class="sp-parent-banner__label">Type d'intervention parent</span>
          <span class="sp-parent-banner__value">{{ modalParentTypeInterventionLibelle }}</span>
        </div>

        <div class="sp-modal-section">
          <div class="sp-section-title">Identification</div>

          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">label_outline</span>
              Type intervention enfant
            </label>
            <div class="sp-locked-field">
              <span class="material-icons sp-locked-field__icon">lock_outline</span>
              <span class="sp-locked-field__value">{{ newSubStructureTypeId }}</span>
            </div>
          </div>

          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">tag</span>
              Code
            </label>
            <app-input label="Code" type="text" placeholder="ex. SP-001" [(ngModel)]="code" />
          </div>

          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">description</span>
              Libellé de l'intervention
            </label>
            <app-input label="Libellé" type="textarea" placeholder="Décrivez l'intervention…" [(ngModel)]="newSubStructureLibelle" />
          </div>
        </div>

        <div class="sp-modal-section">
          <div class="sp-section-title">Chronogramme</div>
          <div class="sp-chrono-row">
            <div class="sp-modal-field">
              <label class="sp-label">
                <span class="material-icons sp-label__icon">event</span>Date de début
              </label>
              <div class="sp-input-wrap">
                <span class="sp-input-icon material-icons">calendar_today</span>
                <input #modalStartRef type="date" [(ngModel)]="dateDebut" class="sp-input"
                  aria-label="Date de début"
                  (focus)="openDatePicker(modalStartRef)" (click)="openDatePicker(modalStartRef)" />
              </div>
            </div>
            <div class="sp-modal-field">
              <label class="sp-label">
                <span class="material-icons sp-label__icon">event_busy</span>Date de fin
              </label>
              <div class="sp-input-wrap">
                <span class="sp-input-icon material-icons">calendar_today</span>
                <input #modalEndRef type="date" [(ngModel)]="dateFin" class="sp-input"
                  aria-label="Date de fin"
                  (focus)="openDatePicker(modalEndRef)" (click)="openDatePicker(modalEndRef)" />
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="sp-modal-footer">
        <app-ui-button label="Annuler" variant="ghost" (clicked)="closeAddSubStructureModal()" />
        <app-ui-button label="Ajouter" variant="primary" iconLeft="add_circle_outline" type="submit"
          [loading]="isLoadingChild" (clicked)="addSubStructureProgrammatique()" />
      </div>
    </div>
  </app-modal>
</ng-template>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- MODAL : Éditer une intervention                                           -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<ng-template #modalEdit>
  <app-modal
    [isVisible]="showEditStructureModal"
    title="Modifier l'intervention"
    (closeEvent)="closeEditStructureModal()"
  >
    <div class="sp-modal-content">
      <div class="sp-modal-scrollable">

        <div class="sp-modal-section">
          <div class="sp-section-title">Classification</div>

          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">category</span>Type d'intervention
            </label>
            <app-select
              label="Type d'intervention"
              [options]="typeInterventionOptions"
              placeholder="Sélectionner un type…"
              [(ngModel)]="editStructureTypeInterventionId"
            />
          </div>

          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">tag</span>Code
            </label>
            <app-input label="Code" type="text" placeholder="ex. CP-001" [(ngModel)]="code" />
          </div>
        </div>

        <div class="sp-modal-section">
          <div class="sp-section-title">Contenu</div>
          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">description</span>Libellé
            </label>
            <app-input label="Libellé" type="textarea" placeholder="Décrivez l'intervention…" [(ngModel)]="editStructureLibelle" />
          </div>
        </div>

        <div class="sp-modal-section">
          <div class="sp-section-title">Chronogramme</div>
          <div class="sp-chrono-row">
            <div class="sp-modal-field">
              <label class="sp-label">
                <span class="material-icons sp-label__icon">event</span>Date de début
              </label>
              <div class="sp-input-wrap">
                <span class="sp-input-icon material-icons">calendar_today</span>
                <input #editStartRef type="date" [(ngModel)]="dateDebut" class="sp-input"
                  aria-label="Date de début"
                  (focus)="openDatePicker(editStartRef)" (click)="openDatePicker(editStartRef)" />
              </div>
            </div>
            <div class="sp-modal-field">
              <label class="sp-label">
                <span class="material-icons sp-label__icon">event_busy</span>Date de fin
              </label>
              <div class="sp-input-wrap">
                <span class="sp-input-icon material-icons">calendar_today</span>
                <input #editEndRef type="date" [(ngModel)]="dateFin" class="sp-input"
                  aria-label="Date de fin"
                  (focus)="openDatePicker(editEndRef)" (click)="openDatePicker(editEndRef)" />
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="sp-modal-footer">
        <app-ui-button label="Annuler" variant="ghost" (clicked)="closeEditStructureModal()" />
        <app-ui-button label="Mettre à jour" variant="primary" iconLeft="save" type="submit"
          [loading]="isLoading" (clicked)="saveEditedStructure()" />
      </div>
    </div>
  </app-modal>
</ng-template>

<!-- ══════════════════════════════════════════════════════════════════════════ -->
<!-- MODAL : Détails                                                           -->
<!-- ══════════════════════════════════════════════════════════════════════════ -->
<ng-template #modalDetails>
  <app-modal
    [isVisible]="showDetailsModal"
    title="Détails de l'intervention"
    (closeEvent)="closeDetailsModal()"
  >
    <div class="sp-modal-content">
      <div class="sp-modal-scrollable">

        <div class="sp-modal-section">
          <div class="sp-section-title">Identification</div>

          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">category</span>Type d'intervention
            </label>
            <div class="sp-read-panel">{{ getTypeInterventionLibelle(detailsStructure?.typeActivite) }}</div>
          </div>

          <div class="sp-field-row">
            <div class="sp-modal-field">
              <label class="sp-label">
                <span class="material-icons sp-label__icon">tag</span>Code
              </label>
              <div class="sp-read-panel sp-read-panel--center">
                <span class="sp-code-badge">{{ detailsStructure?.code }}</span>
              </div>
            </div>
            <div class="sp-modal-field">
              <label class="sp-label">
                <span class="material-icons sp-label__icon">title</span>Titre
              </label>
              <div class="sp-read-panel">{{ detailsStructure?.titre }}</div>
            </div>
          </div>

          <div class="sp-modal-field">
            <label class="sp-label">
              <span class="material-icons sp-label__icon">account_tree</span>Hiérarchie parente
            </label>
            <div class="sp-read-panel">
              <ng-container *ngIf="detailsParentChain.length > 0; else noParent">
                <div class="sp-breadcrumb">
                  <ng-container *ngFor="let p of detailsParentChain; let i = index">
                    <span>{{ p }}</span>
                    <span *ngIf="i < detailsParentChain.length - 1" class="sp-breadcrumb__sep">›</span>
                  </ng-container>
                </div>
              </ng-container>
              <ng-template #noParent>
                <span class="sp-read-panel--muted">—</span>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="sp-modal-section">
          <div class="sp-section-title">Chronogramme</div>
          <div class="sp-chrono-row">
            <div class="sp-date-card sp-date-card--start">
              <div class="sp-date-card__label">Date de début</div>
              <div class="sp-date-card__value">{{ formatDetailDate(detailsStructure?.dateDebut) || '—' }}</div>
            </div>
            <div class="sp-date-card sp-date-card--end">
              <div class="sp-date-card__label">Date de fin</div>
              <div class="sp-date-card__value">{{ formatDetailDate(detailsStructure?.dateFin) || '—' }}</div>
            </div>
          </div>
        </div>

      </div>

      <div class="sp-modal-footer">
        <app-ui-button label="Fermer" variant="secondary" iconLeft="close" (clicked)="closeDetailsModal()" />
      </div>
    </div>
  </app-modal>
</ng-template>